module.exports = __webpack_public_path__ + "static/13.1-fad2aaaa51cab589fe8e00fb728ff87a.jpg";